import { Validator } from './Validator';
import { ReactError } from 'consts/ReactError';

export type FormErrors = {
	gid: string;
	pass: string;
	password_confirm: string;
	lastname: string;
	firstname: string;
	kana_lastname: string;
	kana_firstname: string;
	sex: string;
	birthYear: string;
	birthMonth: string;
	birthDate: string;
};

export const initialFormErrors: FormErrors = {
	gid: '',
	pass: '',
	password_confirm: '',
	lastname: '',
	firstname: '',
	kana_lastname: '',
	kana_firstname: '',
	sex: '',
	birthYear: '',
	birthMonth: '',
	birthDate: '',
};

/**
 * 項目ごとにバリデーションチェックをし、エラーメッセージを返す
 * @param name 項目名
 * @param value 値
 * @param displayType 表示タイプ 1：表示＆必須入力, 2：表示＆任意入力
 * @returns エラーメッセージ or 空文字
 */
export const getErrorMessage = <T>(name: string, value: T, displayType: number): string => {
	const validator = new Validator(value);
	const isRequired = 1 === displayType;
	const isNone = 3 === displayType;
	// 非表示項目の場合スルー
	if (isNone) {
		return '';
	}
	switch (name) {
		case 'gid':
			if (isRequired) {
				validator.require();
			}
			return validator.charTypeGakkenId().end();
		case 'pass':
		case 'password_confirm':
			if (isRequired) {
				validator.require();
			}
			return validator.charTypePassword().end();
		case 'lastname':
		case 'firstname':
			if (isRequired) {
				validator.require();
			}
			return validator.charTypeFullWidth(ReactError.E0007).end();
		case 'kana_lastname':
		case 'kana_firstname':
			if (isRequired) {
				validator.require();
			}
			return validator.charTypeFullWidthKana(ReactError.E0006).end();
		case 'birthYear':
		case 'birthMonth':
		case 'birthDate':
			if (isRequired) {
				return validator.require().end();
			}
			return '';
		case 'sex':
			if (isRequired) {
				return validator.require().end();
			}
			return '';
		default:
			return '';
	}
};
